import cf from './cf';
import c40v from './c40v_20211024';

export default class c40v1a extends c40v { // 機能情報

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
//    this.class = this.constructor.name;
    this.class = 'c40v1a';
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
